/**
 * 二維碼
 */
export const QrcodeEnum = Object.freeze({

    /**
     * 登入
     */
    LOGIN: 0,

    /**
     * 二級驗證
     */
    FACTORY: 1,

    /**
     * 安全性綁定
     */
    MAPPING: 2,

})

/**
 * 二維碼 - 請求類型
 */
export const QrcodeRequestEnum = Object.freeze({

    /**
     * 二級驗證
     */
    FACTORY: "factory",

    /**
     * 用戶綁定管理員
     */
    MAPPING: "mapping",

})

/**
 * 二維碼 - 狀態
 */
export const QrcodeStatusEnum = Object.freeze({

    /**
     * 已驗證
     */
    INSPECTION: 1,

    /**
     * 已授權
     */
    AUTHORIZED: 2,

    /**
     * 超時
     */
    EXPIRE: 3,

})

/**
 * 二維碼 - 顯示端輪詢 - 回應狀態
 *
 * 對應後端 FactoryController 的 FACTORY_STATUS_STRING_* 常數
 */
export const QrcodeRespondStatusEnum = Object.freeze({

    /**
     * 尚未掃描 / 已過期
     */
    PENDING: "pending",

    /**
     * 已掃描待授權
     */
    INSPECTED: "inspected",

    /**
     * 已授權 (附帶登入權杖)
     */
    AUTHORIZED: "authorized",

    /**
     * 已取消
     */
    CANCELLED: "cancelled",

})

/**
 * 二維碼 - 二級驗證 - 指令
 */
export const QrcodeFactoryCommandEnum = Object.freeze({

    /**
     * 驗證
     * UI顯示掃碼成功
     */
    INSPECTION: "factoryInspection",

    /**
     * 確認授權
     * 用戶端在App上按確認授權
     */
    AUTHORIZED: "factoryAuthorize",

    /**
     * 取消
     * 用戶端在App上取消
     */
    CANCEL: "factoryCancel",

})

/**
 * 二維碼 - 顯示端即時推播 - 事件名
 *
 * 對應後端 sse/SseEvent.java 的 FACTORY_* 常數（逐字相同）。
 * ⚠️ 事件本身不帶登入權杖，只是「狀態變了」的訊號；
 *    權杖仍由 GET /api/factory/qrcode/status 領取（終態領取後即 evict，一次性）。
 */
export const QrcodeStreamEventEnum = Object.freeze({

    /**
     * 已掃描待授權
     */
    INSPECTION: "factoryInspection",

    /**
     * 已授權
     */
    AUTHORIZE: "factoryAuthorize",

    /**
     * 已取消
     */
    CANCEL: "factoryCancel",

})
